module.exports = __webpack_public_path__ + "img/chevron-down-blue.eab9b898.svg";